import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { FaArrowLeft, FaTimes, FaCamera } from 'react-icons/fa';

const API = 'https://sendvigo-backend-production.up.railway.app';
const MAX_DETALLE = 500;

const CATEGORIAS = [
  {
    id: 'fraude',
    emoji: '🚨',
    label: 'Actividad fraudulenta',
    subcategorias: ['Intento de estafa', 'Me han estafado', 'Información falsa sobre el envío']
  },
  {
    id: 'comportamiento',
    emoji: '⚠️',
    label: 'Comportamiento inapropiado',
    subcategorias: ['Comportamiento agresivo', 'Propuestas inapropiadas', 'Comportamiento ilegal']
  },
  {
    id: 'perfil',
    emoji: '👤',
    label: 'Perfil incorrecto',
    subcategorias: ['Perfil falso', 'Foto ofensiva', 'Varios perfiles del mismo usuario']
  },
  {
    id: 'contribucion',
    emoji: '💰',
    label: 'Contribución o pagos sospechosos',
    subcategorias: ['Pedía más contribución de la publicada', 'Método de pago sospechoso', 'No respetó el acuerdo económico']
  }
];

// packageId es opcional — si el reporte viene desde el chat de un envío, se pasa
// aquí y queda vinculado, para que el admin pueda revisar esa conversación.
export default function ReportModal({ userId, userName, packageId = null, onClose }) {
  const { token } = useAuth();
  const [paso, setPaso] = useState(1);
  const [categoria, setCategoria] = useState(null);
  const [subcategoria, setSubcategoria] = useState(null);
  const [detalle, setDetalle] = useState('');
  const [captura, setCaptura] = useState(null);
  const [capturaPreview, setCapturaPreview] = useState(null);
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [error, setError] = useState('');

  const handleCapturaChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setCaptura(file);
    setCapturaPreview(URL.createObjectURL(file));
  };

  const handleEnviar = async () => {
    setEnviando(true);
    setError('');
    try {
      const formData = new FormData();
      formData.append('toUserId', userId);
      formData.append('categoria', categoria.label);
      formData.append('subcategoria', subcategoria);
      formData.append('detalle', detalle);
      if (packageId) formData.append('packageId', packageId);
      if (captura) formData.append('captura', captura);

      const res = await fetch(`${API}/reports`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` }, // sin Content-Type: el navegador pone el boundary del multipart
        body: formData
      });
      if (!res.ok) throw new Error('El servidor rechazó el reporte');
      setEnviado(true);
    } catch {
      setEnviando(false);
      setError('No se pudo enviar el reporte. Inténtalo de nuevo en unos segundos.');
    }
  };

  return (
    <div style={{position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
      backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 1000, display: 'flex',
      alignItems: 'flex-end', justifyContent: 'center'}}>
      <div style={{backgroundColor: '#111318', borderRadius: '20px 20px 0 0',
        width: '100%', maxWidth: '480px', padding: '24px', maxHeight: '85vh', overflowY: 'auto'}}>

        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          {paso > 1 && !enviado ? (
            <button onClick={() => setPaso(paso - 1)}
              style={{backgroundColor: '#1a1d24', border: '1px solid #2a2d35',
                color: '#9ca3af', padding: '8px', borderRadius: '10px'}}>
              <FaArrowLeft style={{fontSize: '13px'}} />
            </button>
          ) : <div />}
          <p className="text-white font-semibold text-sm">Reportar usuario</p>
          <button onClick={onClose}
            style={{backgroundColor: '#1a1d24', border: '1px solid #2a2d35',
              color: '#9ca3af', padding: '8px', borderRadius: '10px'}}>
            <FaTimes style={{fontSize: '13px'}} />
          </button>
        </div>

        {/* Enviado */}
        {enviado && (
          <div className="text-center py-8">
            <p style={{fontSize: '40px', marginBottom: '16px'}}>✅</p>
            <p className="text-white font-semibold text-base mb-2">Reporte enviado</p>
            <p style={{color: '#9ca3af', fontSize: '13px', marginBottom: '24px'}}>
              Gracias por ayudarnos a mantener la comunidad segura. Podrás ver la respuesta
              y seguir la conversación desde "Mis reportes" en tu perfil.
            </p>
            <button onClick={onClose}
              style={{backgroundColor: '#f97316', color: 'white', padding: '12px 32px',
                borderRadius: '14px', fontWeight: '600', fontSize: '14px'}}>
              Cerrar
            </button>
          </div>
        )}

        {/* Paso 1 — Categoría */}
        {!enviado && paso === 1 && (
          <>
            <p style={{color: '#9ca3af', fontSize: '13px', marginBottom: '20px'}}>
              ¿Sobre qué quieres alertarnos sobre <strong style={{color: 'white'}}>{userName}</strong>?
            </p>
            <div className="flex flex-col gap-3">
              {CATEGORIAS.map(cat => (
                <button key={cat.id} onClick={() => { setCategoria(cat); setPaso(2); }}
                  style={{backgroundColor: '#1a1d24', border: '1px solid #2a2d35',
                    borderRadius: '14px', padding: '14px', textAlign: 'left',
                    display: 'flex', alignItems: 'center', gap: '12px'}}>
                  <span style={{fontSize: '20px'}}>{cat.emoji}</span>
                  <p style={{color: 'white', fontSize: '14px', fontWeight: '500'}}>{cat.label}</p>
                </button>
              ))}
            </div>
          </>
        )}

        {/* Paso 2 — Subcategoría */}
        {!enviado && paso === 2 && (
          <>
            <p style={{color: '#9ca3af', fontSize: '13px', marginBottom: '20px'}}>
              {categoria?.emoji} <strong style={{color: 'white'}}>{categoria?.label}</strong> — ¿Qué ocurrió exactamente?
            </p>
            <div className="flex flex-col gap-3">
              {categoria?.subcategorias.map(sub => (
                <button key={sub} onClick={() => { setSubcategoria(sub); setPaso(3); }}
                  style={{backgroundColor: '#1a1d24', border: '1px solid #2a2d35',
                    borderRadius: '14px', padding: '14px', textAlign: 'left'}}>
                  <p style={{color: 'white', fontSize: '14px'}}>{sub}</p>
                </button>
              ))}
            </div>
          </>
        )}

        {/* Paso 3 — Detalle */}
        {!enviado && paso === 3 && (
          <>
            <p style={{color: '#9ca3af', fontSize: '13px', marginBottom: '20px'}}>
              ¿Puedes darnos más detalles? <span style={{color: '#3a3d45'}}>(opcional)</span>
            </p>
            <textarea
              value={detalle}
              onChange={e => { if (e.target.value.length <= MAX_DETALLE) setDetalle(e.target.value); }}
              placeholder="Describe brevemente lo que pasó..."
              rows={5}
              style={{backgroundColor: '#1a1d24', border: '1px solid #2a2d35', color: 'white',
                borderRadius: '12px', padding: '12px 14px', fontSize: '14px',
                width: '100%', resize: 'none', marginBottom: '8px'}}
              className="focus:outline-none focus:ring-1 focus:ring-orange-500 placeholder-gray-600"
            />
            <p style={{color: '#3a3d45', fontSize: '11px', textAlign: 'right', marginBottom: '16px'}}>
              {detalle.length}/{MAX_DETALLE}
            </p>

            {/* Captura de pantalla */}
            <label style={{
              display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer',
              backgroundColor: '#1a1d24', border: '1px dashed #2a2d35', borderRadius: '12px',
              padding: '12px 14px', marginBottom: '20px',
            }}>
              <input type="file" accept="image/*" onChange={handleCapturaChange} style={{ display: 'none' }} />
              {capturaPreview ? (
                <img src={capturaPreview} alt="" style={{ width: '40px', height: '40px', borderRadius: '8px', objectFit: 'cover' }} />
              ) : (
                <FaCamera style={{ color: '#6b7280', fontSize: '16px' }} />
              )}
              <span style={{ color: '#9ca3af', fontSize: '12px' }}>
                {captura ? captura.name : 'Adjuntar captura de pantalla (opcional)'}
              </span>
            </label>

            {error && (
              <p style={{color: '#f87171', fontSize: '12px', marginBottom: '12px', textAlign: 'center'}}>
                {error}
              </p>
            )}
            <button onClick={handleEnviar} disabled={enviando}
              style={{width: '100%', backgroundColor: '#f97316', color: 'white',
                padding: '14px', borderRadius: '14px', fontWeight: '600', fontSize: '14px',
                opacity: enviando ? 0.5 : 1}}>
              {enviando ? 'Enviando...' : 'Enviar reporte'}
            </button>
          </>
        )}
      </div>
    </div>
  );
}